import { categoryData } from '../../../../component-classes/data/category.data';
import { ToolResult } from '../../types';

export interface ApplianceCategory {
	key: string;
	displayName: string;
}

const INTERNAL_CATEGORIES = ['system', 'vent', 'passthrough'];

export const getApplianceCategoriesTool = (): ToolResult<ApplianceCategory[]> => {
	const categories: ApplianceCategory[] = categoryData
		.filter((c) => c.active && !INTERNAL_CATEGORIES.includes(c.key))
		.sort((a, b) => a.sort - b.sort)
		.map((c) => ({
			key: c.id,
			displayName: c.description
		}));

	return {
		success: true,
		message: `Found ${categories.length} appliance categories.`,
		data: categories
	};
};
